import React from 'react';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function ClosingSection() {
  return <section className="py-16 md:py-24 bg-charcoal text-white text-center relative overflow-hidden pb-32 md:pb-24" data-id="element-23">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-5" data-id="element-24">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary rounded-full blur-3xl" data-id="element-25"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-26">
        <h2 className="text-3xl md:text-5xl font-heading font-black mb-6 leading-tight" data-id="element-27">
          Deja de Perder Tiempo Hoy:{' '}
          <span className="text-primary block mt-2" data-id="element-28">
            Últimas Horas de esta Oferta
          </span>
        </h2>

        <div className="flex items-center justify-center gap-3 text-xl md:text-2xl mb-10 bg-white/10 py-3 px-6 rounded-full inline-flex mx-auto border border-white/20" data-id="element-29">
          <span data-id="element-30">La oferta expira en:</span>
          <CountdownTimer minutes={10} className="text-primary" data-id="element-31" />
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 mb-10 text-left max-w-xl mx-auto" data-id="element-32">
          <ul className="space-y-4" data-id="element-33">
            <li className="flex items-center gap-3" data-id="element-34">
              <CheckCircle2 className="w-6 h-6 text-trust shrink-0" data-id="element-35" />
              <span className="text-lg" data-id="element-36">Prepara típico sin paila</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-37">
              <CheckCircle2 className="w-6 h-6 text-trust shrink-0" data-id="element-38" />
              <span className="text-lg" data-id="element-39">
                Logra el "crunch" con el golpe de calor final
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-40">
              <CheckCircle2 className="w-6 h-6 text-trust shrink-0" data-id="element-41" />
              <span className="text-lg" data-id="element-42">
                Cocina sin dejar tu apartamento oliendo a frito
              </span>
            </li>
          </ul>
        </div>

        <div className="flex flex-col items-center" data-id="element-43">
          <a id="buyNowBottom" href="https://krove.lat//cart/40654113177729:1" className="w-full max-w-md bg-primary hover:bg-primary-hover text-white font-heading font-black text-xl py-5 px-8 rounded-xl shadow-[0_10px_25px_-5px_rgba(232,93,4,0.6)] hover:shadow-[0_15px_30px_-5px_rgba(232,93,4,0.8)] hover:-translate-y-1 transition-all duration-200 uppercase tracking-wide text-center" data-id="element-44">
            Comprar ahora por $23.999 COP
          </a>

          <p className="text-sm text-gray-400 mt-4 flex items-center justify-center gap-2 flex-wrap" data-id="element-45">
            Entrega inmediata por email •{' '}
            <ShieldCheck className="w-4 h-4 text-trust inline" data-id="element-46" /> Garantía 7
            días • Pago seguro
          </p>
        </div>
      </div>
    </section>;
}